import { defineMessages } from 'react-intl'

const scope = `procurify.expenses.ExpenseRevisePage`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Expense report details',
  },
  expenseStatusBreadcrumb: {
    id: `${scope}.expenseStatusBreadcrumb`,
    defaultMessage: 'Expense reports',
  },
})
